import { observable, action, computed, autorun, reaction, toJS } from 'mobx'

const TOKEN_KEY = 'token'
const PROJECT_KEY = 'project'
const USER_KEY = 'user'

class AuthStore {
  @observable token = ''
  @observable project = {}
  @observable user = {}
  @observable menuItems = {}
  @observable isAuthenticated = false
  constructor() {
    // reaction(
    //   () => this.token,
    //   token => {
    //     if (token) {
    //       window.localStorage.setItem(TOKEN_KEY, token);
    //     } else {
    //       window.localStorage.removeItem(TOKEN_KEY);
    //     }
    //   }
    // );
    // reaction(
    //   () => this.user,
    //   user => {
    //     if (user) {
    //       window.localStorage.setItem(USER_KEY, user);
    //     } else {
    //       window.localStorage.removeItem(USER_KEY);
    //     }
    //   }
    // );
    // reaction(
    //   () => this.project,
    //   project => {
    //     if (project) {
    //       window.localStorage.setItem(PROJECT_KEY, project);
    //     } else {
    //       window.localStorage.removeItem(PROJECT_KEY);
    //     }
    //   }
    // );
  }

  @action
  setToken(data) {
    localStorage.setItem(TOKEN_KEY, data)
    this.token = data
    this.isAuthenticated = true
  }

  @action
  setProject(data) {
    localStorage.setItem(PROJECT_KEY, JSON.stringify(data))
    this.prject = data
  }

  @action
  setUser(data) {
    localStorage.setItem(USER_KEY, JSON.stringify(data))
    this.user = data
  }
  @action
  setMenu(data) {
    this.menuItems = data
  }
  @action
  signout() {
    this.isAuthenticated = false
    localStorage.removeItem(USER_KEY)
    localStorage.removeItem(PROJECT_KEY)
    localStorage.removeItem(TOKEN_KEY)
    this.user = null
    this.project = null
    this.token = null
    return Promise.resolve()
  }

  @action
  getToken() {
    return this.token ? this.token : ''
  }
  @action
  getProject() {
    return this.user !== undefined ? JSON.parse(this.project) : ''
  }

  @action
  getUser() {
    return this.user !== undefined ? JSON.parse(this.user) : {}
  }
  @action
  geMenuItems() {
    return this.menuItems !== undefined ? toJS(this.menuItems): []
  }

  @action
  isLoggedIn() {
    return this.isAuthenticated
  }

  @action clearStore() {
    window.localStorage.removeItem(USER_KEY)
    window.localStorage.removeItem(PROJECT_KEY)
    window.localStorage.removeItem(TOKEN_KEY)
  }
}

export default new AuthStore()
